import { Injectable } from '@angular/core';
import { IAPIService } from './API-Service/IAPIService';
import { IClassService, ClassService } from './class-service';
import { ITeacherService, TeacherService } from './teacher-service';
import { SpinnerService } from './spinner-service';
import { FilterService } from './filter-service';
import { StateService, IStateService } from './state-service';
import { IStudentLessonService, StudentLessonService } from './student-lesson-service';
import { GradebookDataService } from './gradebookData.service';
import { DiagnosticsDataService } from './diagnosticsData.service';
import { SelectionService } from './selection.service';
import { AssignmentFilterService } from './filter.service';
import { CreateAccountService } from './create-account.service';
import { CurriculumService } from './curriculum.service';
import { RouterService } from './router-service';

export abstract class IServiceFactory {
    abstract getAssignmentFilterService(): AssignmentFilterService;
    abstract getSelectionService(): any;
    abstract getClassService() : IClassService;
    abstract getTeacherService() : ITeacherService;
    abstract getFilterService(): FilterService;
    abstract getStateService(): IStateService;
    abstract getSpinnerService(): SpinnerService;
    abstract getStudentLessonService(): IStudentLessonService;
    abstract getGradebookDataService(): GradebookDataService;
    abstract getDiagnosticsDataService() : DiagnosticsDataService;
    abstract getCreateAccountService() : CreateAccountService;
    abstract getCurriculumService() : CurriculumService;
    abstract getRouterService(): RouterService;
}

@Injectable({
    providedIn: 'root'
  })
export class ServiceFactory implements IServiceFactory{
    TeacherService: ITeacherService;
    ClassService: IClassService;
    SpinnerService: SpinnerService;
    FilterService: FilterService = new FilterService();
    StateService: StateService;
    StudentLessonService: IStudentLessonService;
    GradebookDataService: GradebookDataService;
    DiagnosticsDataService: DiagnosticsDataService;
    selectionService: SelectionService;
    assignmentFilterService: AssignmentFilterService;
    CreateAccountService: CreateAccountService;
    CurriculumService: CurriculumService
    RouterService: RouterService;

    constructor(private APIService: IAPIService){
        this.APIService.SetServiceFactory(this);
    }

    getRouterService(): RouterService{
        if (!this.RouterService){
            this.RouterService = new RouterService(this.APIService);
        }

        return this.RouterService;
    }

    getAssignmentFilterService(): AssignmentFilterService {
        if (!this.assignmentFilterService){
            this.assignmentFilterService = new AssignmentFilterService();
        }

        return this.assignmentFilterService;
    }

    getSelectionService(): SelectionService {
        if (!this.selectionService){
            this.selectionService = new SelectionService();
        }

        return this.selectionService;
    }

    getStudentLessonService(){
        if(!this.StudentLessonService){
            this.StudentLessonService = new StudentLessonService(this.APIService);
        }

        return this.StudentLessonService;
    }

    getSpinnerService(): SpinnerService{
        if(!this.SpinnerService){
            this.SpinnerService = new SpinnerService();
        }
        return this.SpinnerService;
    }

    getClassService(): IClassService {
        if (!this.ClassService){
            this.ClassService = new ClassService(this.APIService);
        }

        return this.ClassService;
    }
    getTeacherService(): ITeacherService {
        if (!this.TeacherService){
            this.TeacherService = new TeacherService(this.APIService);
        }

        return this.TeacherService;
    }


    getFilterService():FilterService{
        if(!this.FilterService){
            this.FilterService = new FilterService();
        }

        return this.FilterService;
    }

    getStateService(){
        if(!this.StateService){
            this.StateService = new StateService(this.APIService);
        }
        return this.StateService;
    }

    getGradebookDataService(): GradebookDataService {
        if (!this.GradebookDataService){
            this.GradebookDataService = new GradebookDataService(this.APIService);
        }

        return this.GradebookDataService;
    }

    getDiagnosticsDataService(): DiagnosticsDataService {
      if (!this.DiagnosticsDataService){
          this.DiagnosticsDataService = new DiagnosticsDataService(this.APIService);
      }

      return this.DiagnosticsDataService;
  }

  getCreateAccountService(): CreateAccountService {
    if (!this.CreateAccountService){
        this.CreateAccountService = new CreateAccountService(this.APIService);
    }

    return this.CreateAccountService;
    }

    getCurriculumService(): CurriculumService {
    if (!this.CurriculumService){
        this.CurriculumService = new CurriculumService(this.APIService);
    }
    
    return this.CurriculumService;
    }
}
